import { createHolidayDatesSelector } from 'selectors/holidaySelectors'
import { identityPropsSelector, useParametricSelector } from 'utils'

const holidaysSelector = createHolidayDatesSelector(identityPropsSelector)
export const useHolidays = (currency: string | null | undefined) => useParametricSelector(holidaysSelector, currency)
